import type { ReactNode } from 'react'

const escapeRegex = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

/**
 * Wrap each occurrence of `query` inside `text` with a styled `<mark>`.
 * Match is case-insensitive; original casing in the source text is preserved.
 * Returns a single string when there are no matches (no React overhead).
 */
export function highlightMatch(
  text: string,
  query: string | null | undefined,
): ReactNode {
  if (!text) return text
  const q = (query ?? '').trim()
  if (!q) return text

  const re = new RegExp(`(${escapeRegex(q)})`, 'gi')
  const parts = text.split(re)
  if (parts.length === 1) return text

  return parts.map((part, i) =>
    i % 2 === 1 ? (
      <mark
        key={i}
        className="rounded-sm bg-[#F6CB86]/20 px-0.5 font-bold text-[#F6CB86]"
      >
        {part}
      </mark>
    ) : (
      part
    ),
  )
}
